import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseFilesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseFile/${props.receivedFileId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseFile/Franchise/${props.franchiseId}`, method: 'POST', payload: props, multipart: true, secure: true });
    }, [execute]);
    
    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseFile/UpdateFranchiseFile/${props.receivedFileId}`, method: 'PUT', payload: props, multipart: true, secure: true });
    }, [execute]);

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `FranchiseFile/Franchise/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseFile/${props.receivedFileId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, createRecord, updateRecord, newRecord, deleteRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseFilesStore = () => React.useContext(Context);
